import { getNetwork, getNoopNetwork } from '../src/getNetwork';

export const network = getNetwork();

export const noopNetwork = getNoopNetwork();
